import { Typography } from "@mui/material";
import { HStack } from "@zfp-akademie-a-s/zfp-design";
import { ErrorIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Spacing } from "Infrastructure/Themes/Themes";

export const DialogErrorText = ({ text }: { readonly text: string }) => (
  <HStack role="alert" alignItems="flex-start" spacing={Spacing.S} color="error.main">
    <ErrorIcon fontSize="small" />
    <Typography variant="body2" color="inherit">
      {text}
    </Typography>
  </HStack>
);
